import { INT_RANGE_WITH_SPACE_AROUND_DASH_REGEX, POSITIVE_INT_REGEX } from '../../Integer/consts'

export const parseRangeIntoIntegers = (str: string) => {
    const trimmed = str.trim()
    if (!trimmed) return []

    let integers: bigint[] = []

    if (POSITIVE_INT_REGEX.test(trimmed)) {
        const int = BigInt(trimmed)
        integers = [int]

        return integers
    }

    const rangeMatch = trimmed.match(INT_RANGE_WITH_SPACE_AROUND_DASH_REGEX)
    if (rangeMatch) {
        let start
        let end

        try {
            start = BigInt(rangeMatch[1])
            end = BigInt(rangeMatch[2])
        } catch(e){
            return integers
        }

        for (let i = start; i <= end; i++) {
            integers.push(i)
        }
        return integers
    }

    return integers
}
